import CampaignsService from 'services/campaignsService';
import { CampaignOwnership } from 'types/campaigns';
import { ApiRequestBody } from 'interfaces/ApiRequestBody';

interface SetCampaignOwnershipRequest extends CampaignOwnership, ApiRequestBody {}

const setCampaignOwnership = async (
  requestBody: SetCampaignOwnershipRequest
): Promise<number | undefined> => {
  const { getAuthToken, ...requestProperties } = requestBody;

  const token = await getAuthToken();

  const service = new CampaignsService(token);

  const result = await service.campaignsService.post('SetCampaignOwnership', {
    ...requestProperties,
  });

  return result.status;
};

export default setCampaignOwnership;
